import PropTypes from "prop-types";
import colors from "constants/colors";

function IconSearch({ fill }) {
    return (
        <svg viewBox="0 0 41 40">
            <g fill={fill}>
                <path d="M16.9036421,0 C26.2262568,0 33.8072841,7.58102735 33.8072841,16.9036421 C33.8072841,20.9020049 32.4127891,24.5800107 30.0844844,27.476974 L40.4331225,37.8268063 L38.2599288,40 L27.9495695,29.6903933 C24.985152,32.2545614 21.1227503,33.8072841 16.9036421,33.8072841 C7.58102735,33.8072841 0,26.2262568 0,16.9036421 C0,7.58102735 7.58102735,0 16.9036421,0 Z M16.9036421,3.07338947 C9.32261472,3.07338947 3.07338947,9.32261472 3.07338947,16.9036421 C3.07338947,24.4846694 9.32261472,30.7338947 16.9036421,30.7338947 C24.4846694,30.7338947 30.7338947,24.5871157 30.7338947,16.9036421 C30.7338947,9.2201684 24.5871157,3.07338947 16.9036421,3.07338947 Z" />
            </g>
        </svg>
    );
}

IconSearch.propTypes = {
    fill: PropTypes.string
};

IconSearch.defaultProps = {
    fill: colors.darkNight
};

export default IconSearch;
